import React from 'react'

const Shop = () => {
    return (
        <div className="page">
            <h1 className="page-title">
                shop
            </h1>
        </div>
    )
}

export default Shop
